export default __webpack_public_path__ + "e1426c481deca3ddeea0321f8886f035.png";